module.exports = __webpack_public_path__ + "img/percent_stacked_area.abe29671.svg";